module.exports = __webpack_public_path__ + "img/thumbnail-video.316ae96.png";